module.exports = __webpack_public_path__ + "static/media/icon_info_inactive.86386af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/icon_info_inactive.png
// module id = 439
// module chunks = 0